module.exports = __webpack_public_path__ + "static/media/harvard 1.69674602.png";